module.exports = __webpack_public_path__ + "img/wsczzhjkyypt7.336dd7f0.png";